import "@glidejs/glide"

export default () => {
  if (document.querySelector("#offer__gallery")) {
    const slider = new Glide("#offer__gallery", {
      type: "carousel",
      perView: 1,
      peek: {
        before: 0,
        after: 200,
      },
      bound: true,
      breakpoints: {
        768: {
          peek: {
            before: 0,
            after: 50,
          },
        },
      },
    })

    slider.mount()
  }
}
